<template>
<div class="pa-4 ListAll">

    <div v-if="items">

        <v-card v-for="item in items" :key="item.contact_id" class="mx-auto mt-5" tile>

            <v-list-item six-line style="background-color:#e9f8f2;">
                <v-list-item-content>
                    <v-list-item-title style="font-size:1.2rem; color:#266861;font-weight:500" class="mb-2">{{item.fullname}}</v-list-item-title>

                    <v-list-item-subtitle class="mb-3"><b>วันที่ :</b> {{item.created}} <b>โทร :</b> {{item.phone}} <b>อีเมล์ :</b> {{item.email}}</v-list-item-subtitle>
                    <v-list-item-subtitle class="mb-3">
                        <div class="mb-3">{{item.title}}</div>

                        <div><b>CODE :</b> {{item.code}}</div>

                    </v-list-item-subtitle>
                    <v-list-item-subtitle class="mb-3">
                        <div v-if="item.for_sale=='A'"><b>ขาย :</b> {{item.price}}</div>
                        <div v-if="item.for_rent=='A'"><b>ให้เช่า :</b> {{item.price_rent}}</div>
                    </v-list-item-subtitle>

                    <v-list-item-subtitle class="mb-3">
                       
                        <div class="row">
                            <div class="col-sm-6"> {{item.status_title}}</div>
                            <div class="col-sm-6 text-right"><ContactDetail   :contact_id="item.contact_id"  @updateItem="getItems()" /></div>
                        </div>
                    </v-list-item-subtitle>

                </v-list-item-content>
            </v-list-item>

        </v-card>

    </div>
    <div v-if="totalItemsCount==0" class="noList"> ไม่มีรายการค่ะ</div>
    <Paginator v-if="totalItemsCount>per_page" :rows="per_page" :totalRecords="totalItemsCount" @page="onPage($event)"></Paginator>

</div>
</template>

<script>
import ContactDetail from '@/views/Contact/ContactDetail'
export default {

    components: {
        ContactDetail
    },
    props: {
        propType: null
    },

    data: () => ({
        loading: null,
        totalItemsCount: 0,
        per_page: 10,

        open: false,
        contact_id: null,

        items: null,

    }),

    computed: {
        numberOfPages() {
            return Math.ceil(this.items.length / this.itemsPerPage)
        },
        filteredKeys() {
            return this.keys.filter(key => key !== 'Name')
        },
    },

    watch: {

    },
    methods: {

        openDetail(contact_id) {
            this.contact_id = contact_id
            this.open = true;
        },
        nextPage() {
            if (this.page + 1 <= this.numberOfPages) this.page += 1
        },
        formerPage() {
            if (this.page - 1 >= 1) this.page -= 1
        },
        updateItemsPerPage(number) {
            this.itemsPerPage = number
        },

        getItems() {
            let url = "contact/list?page=" + this.page;
            console.log(url)

            this.loading = true

            let $vm = this;
            this.$http
                .post(url, this.formData())
                .then(function (res) {
                    console.log(res.data);

                    $vm.items = res.data.items

                    $vm.totalItemsCount = res.data.total

                    $vm.loading = false
                })
                .catch(function (error) {
                    console.log(error);
                });

        },
        onPage(event) {

            this.page = event.page + 1
            this.getItems()
        },

    },
    created() {
        this.getItems()

    },
};
</script>
